import Dexie, { Table } from 'dexie'

export interface Pocket {
  id?: string
  _id?: string
  name?: string
  main: boolean
  synced?: number
  deleted: number
  currency?: string
  createdAt: number
  updatedAt: number
  belongsTo?: string
  balance?: number | string
  fundsTransferedTo?: string
  balanceToBeDebited?: number | string
  balanceToBeCredited?: number | string
}

class AdamoPayV2Database extends Dexie {
  pockets!: Table<Pocket>

  constructor() {
    super('adamo-pay-v2')
    this.version(1).stores({
      pockets: 'id, name, main, balance, deleted, createdAt, updatedAt, belongsTo, synced'
    })
  }
}

export const db = new AdamoPayV2Database()
